import { render, staticRenderFns } from "./BasePDFViewer.vue?vue&type=template&id=5ed2f7c0&scoped=true&"
import script from "./BasePDFViewer.vue?vue&type=script&lang=js&"
export * from "./BasePDFViewer.vue?vue&type=script&lang=js&"
import style0 from "./BasePDFViewer.vue?vue&type=style&index=0&id=5ed2f7c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed2f7c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ed2f7c0')) {
      api.createRecord('5ed2f7c0', component.options)
    } else {
      api.reload('5ed2f7c0', component.options)
    }
    module.hot.accept("./BasePDFViewer.vue?vue&type=template&id=5ed2f7c0&scoped=true&", function () {
      api.rerender('5ed2f7c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BasePDFViewer.vue"
export default component.exports